import React, { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { ChevronDownIcon } from '@heroicons/react/outline';
import { motion, AnimatePresence } from 'framer-motion';

const FAQ = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const [expanded, setExpanded] = useState(null);

  const handleChange = (panel) => {
    setExpanded(expanded === panel ? null : panel);
  };

  const faqs = [
    {
      question: "ماهي دوز ؟",
      answer: "هي منصة رقمية الكترونية سعودية متخصصة لإقامة دورات تدريبية في مجالات الرخصة المهنية وأبرز ما تقدمه المنصة حالياً \"دورة العلوم الإدارية  \""
    },
    {
      question: "ماهي طريقة الدورة ؟",
      answer: "تقدم محاضرات منظمة و مسجلة تحفظ في حساب المشترك للمشاهدة في أي وقت يشاء بالإضافة إلى اختبارات تدريبية الكترونية بطُرق ذكية تعزز من تعلمك."
    },
    {
      question: "بماذا تتميز الدورة ؟",
      answer: "تتميز دوراتنا بالعديد من المميزات التي تجعل تجربة التعلم أكثر فعالية وكفاءة:",
      list: [
        "مادة علمية شاملة للمعايير",
        "محاضرات مسجلة",
        "حقيبة الكترونية شاملة",
        "اختبارات دورية",
        "تدريبات مكثفة",
        "مناقشات مع المدرب"
      ]
    },
    {
      question: "إلى متى تبقى المحاضرات في حسابي ؟",
      answer: "حتى يوم الاختبار ، ثم يتم حذفها بشكل تلقائي."
    }
  ];

  return (
    <div className={`min-h-screen py-16 ${isDark ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <div className="max-w-5xl mx-auto px-4">
        <div className={`p-8 rounded-lg mb-8 ${isDark ? 'bg-gray-800' : 'bg-white border border-gray-200'}`}>
          <div className="text-center">
            <h1 className={`text-3xl md:text-4xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
              الأسئلة الشائعة
            </h1>
            <p className={`text-lg ${isDark ? 'text-white' : 'text-gray-600'}`}>
              إجابات على أكثر الأسئلة شيوعاً
            </p>
          </div>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`rounded-lg border ${
                isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
              }`}
            >
              <button
                onClick={() => handleChange(index)}
                className="w-full px-5 py-4 text-right flex items-center justify-between"
              >
                <h3 className={`text-lg font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                  {faq.question}
                </h3>
                <motion.div
                  animate={{ rotate: expanded === index ? 180 : 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <ChevronDownIcon className="h-5 w-5 text-primary-600 dark:text-primary-400" />
                </motion.div>
              </button>

              <AnimatePresence initial={false}>
                {expanded === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="px-5 pb-4">
                      <p className={`text-base ${isDark ? 'text-white' : 'text-gray-600'}`}>
                        {faq.answer}
                      </p>
                      {faq.list && (
                        <ul className="list-disc pr-6 mt-2 space-y-1">
                          {faq.list.map((item, i) => (
                            <li
                              key={i}
                              className={`text-base ${isDark ? 'text-white' : 'text-gray-600'}`}
                            >
                              {item}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
